import { Injectable } from '@angular/core';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { TR } from '../../models/TR';
import { TypeCaracteristiquesMAPA } from '../../models/TypeCaracteristiquesMAPA';
import { TypeOuiNon } from '../../models/TypeOuiNon';
import { TypeTableCar1 } from '../../models/TypeTableCar1';
import { TypeTableMinMax } from '../../models/TypeTableMinMax';

@Injectable({
  providedIn: 'root'
})
export class CaracteristiquesService {

  constructor() {
  }

  getCaracteristiques(controls: any, formExtractorService: FormExtractorService) {
    let tR_iter1 = 0;
    let tR_iterLibre = 0;
    let tR_iterMinMax = 0;

    const tR_iters1 = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_'], 'SepSep_TypeTableCar1_index_');
    const tR_itersLibre = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_'], 'SepSep_TypeTableauLibre_index_');
    const tR_itersMinMax = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_'], 'SepSep_TypeTableMinMax_index_');

    const caracteristiques = new TypeCaracteristiquesMAPA();
    caracteristiques.principales = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_SepAtt_principales'));
    caracteristiques.quantites = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_SepAtt_quantites'));
    caracteristiques.tabCar1 = new TypeTableCar1();
    for (let tr of Array.from(tR_iters1)) {
      caracteristiques.tabCar1.tr[tR_iter1] = new TR();
      caracteristiques.tabCar1.tr[tR_iter1].td = controls.get('_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_SepSep_TypeTableCar1_index_' + (tR_iter1 + 1) + '_SepSep_TR_SepAtt_tD');
      tR_iter1++;
    }
    for (let tr of Array.from(tR_itersLibre)) {
       if(!caracteristiques.tabCarLibre.tr) {
			caracteristiques.tabCarLibre.tr = [];
		  }
      caracteristiques.tabCarLibre.tr[tR_iterLibre] = new TR();
      caracteristiques.tabCarLibre.tr[tR_iterLibre].td = controls.get('_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_SepSep_TypeTableauLibre_index_' + (tR_iterLibre + 1) + '_SepSep_TR_SepAtt_tD');
      tR_iterLibre++;
    }
    caracteristiques.tabCarMinMax = new TypeTableMinMax();
    for (let tr of Array.from(tR_itersMinMax)) {
      caracteristiques.tabCarMinMax.tr[tR_iterMinMax] = new TR();
      caracteristiques.tabCarMinMax.tr[tR_iterMinMax].td = controls.get('_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_SepSep_TypeTableMinMax_index_' + (tR_iterMinMax + 1) + '_SepSep_TR_SepAtt_tD');
      tR_iterMinMax++;
    }
    caracteristiques.variantes = new TypeOuiNon();
    if (controls.get('_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_SepSep_TypeOuiNon_SepAtt_oui') === 'Oui') {
      caracteristiques.variantes.oui = true;
      caracteristiques.variantes.non = null;
    } else if (controls.get('_SepSep_Initial_SepSep_TypeCaracteristiquesMAPA_SepSep_TypeOuiNon_SepAtt_oui') === 'Non') {
      caracteristiques.variantes.oui = null;
      caracteristiques.variantes.non = true;
    } else {
      caracteristiques.variantes.oui = null;
      caracteristiques.variantes.non = null;
    }
    return caracteristiques;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
